// This file could contain JS helpers. Or you could remove it, it's up to you!
export const justTestingAnImport = "I'm here to help!";

export const debounce = (fn, delay = 100) => {
    let timer = null;
    return () => {
        // eslint-disable-next-line consistent-this
        const context = this;
        // eslint-disable-next-line no-undef
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
};

export const throttle = (fn, wait = 100) => {
    let time = Date.now();
    return () => {
        if (time + wait - Date.now() < 0) {
            fn();
            time = Date.now();
        }
    };
};

export const skipToMain = () => {
    const main = document.querySelector('#main');
    const skipBtn = document.querySelector('.skip-to-main');
    const html = document.querySelector('html');

    if (skipBtn) {
        skipBtn.addEventListener('click', () => {
            main.focus();
            setTimeout(() => {
                html.dataset.scrolldir = 'up';
            }, 1000);
        });
    }
};

export const applyNowButton = () => {
    const applyBtn = document.querySelector('.call-to-action-holder');
    const footerTarget = document.querySelector('.lumc-footer');
    if (applyBtn) {
        footerTarget.classList.add('solliciteer-extra-padding');
    }
};

export const printTime = () => {
    const d = new Date();

    const downloadTime = document.querySelector('.download-holder');
    const day = d.getDate();
    const month = d.getMonth();
    let monthDesc;
    const year = d.getFullYear();

    // eslint-disable-next-line default-case
    switch (month) {
        case 0:
            monthDesc = 'januari';
            break;
        case 1:
            monthDesc = 'februari';
            break;
        case 2:
            monthDesc = 'maart';
            break;
        case 3:
            monthDesc = 'april';
            break;
        case 4:
            monthDesc = 'mei';
            break;
        case 5:
            monthDesc = 'juni';
            break;
        case 6:
            monthDesc = 'juli';
            break;
        case 7:
            monthDesc = 'augustus';
            break;
        case 8:
            monthDesc = 'september';
            break;
        case 9:
            monthDesc = 'oktober';
            break;
        case 10:
            monthDesc = 'november';
            break;
        case 11:
            monthDesc = 'december';
            break;
    }

    const today = `${day} ${monthDesc} ${year}`;
    if (downloadTime) {
        downloadTime.innerHTML = `Gedownload op ${today}`;
    }
};
